import { ArrowRight, Pause, Play, Plus, Trash2 } from 'lucide-react';
import Tooltip from '../../../../components/patterns/Tooltip.jsx';
import Button from '../../../../components/primitives/Button.jsx';
import GalleryExample from './GalleryExample.jsx';
import GallerySection from './GallerySection.jsx';

const ButtonsSection = () => {
  return (
    <GallerySection id="buttons" title="Buttons" description="One primary action per view. Labels say exactly what happens.">
      <GalleryExample label="Variants">
        <Button variant="primary">Run now</Button>
        <Button variant="secondary">Edit schedule</Button>
        <Button variant="ghost">Cancel</Button>
        <Button variant="danger" iconStart={Trash2}>
          Delete automation
        </Button>
      </GalleryExample>
      <GalleryExample label="Sizes">
        <Button variant="primary" size="sm" iconStart={Plus}>
          New automation
        </Button>
        <Button variant="primary" size="md" iconStart={Plus}>
          New automation
        </Button>
        <Button variant="primary" size="lg" iconStart={Plus}>
          New automation
        </Button>
      </GalleryExample>
      <GalleryExample label="States">
        <Button variant="primary" loading>
          Connecting
        </Button>
        <Button variant="secondary" loading>
          Saving
        </Button>
        <Button variant="primary" disabled>
          Run now
        </Button>
        <Button variant="secondary" iconEnd={ArrowRight}>
          Continue
        </Button>
      </GalleryExample>
      <GalleryExample label="Icon only, with tooltip">
        <Tooltip content="Pause automation">
          <Button iconOnly label="Pause automation" iconStart={Pause} />
        </Tooltip>
        <Tooltip content="Run now">
          <Button iconOnly variant="ghost" label="Run now" iconStart={Play} />
        </Tooltip>
        <Tooltip content="Delete">
          <Button iconOnly variant="ghost" size="sm" label="Delete" iconStart={Trash2} />
        </Tooltip>
      </GalleryExample>
    </GallerySection>
  );
};

export default ButtonsSection;
